export const USER_SETTING_KEYS = {
  SOUND: 'soundStatus',
  MUSIC: 'musicStatus',
  VIBRATION: 'vibrationStatus'
}

export const DEFAULTS_USER_SETTING = {
  [USER_SETTING_KEYS.MUSIC]: 'false',
  [USER_SETTING_KEYS.SOUND]: 'true',
  [USER_SETTING_KEYS.VIBRATION]: 'false',
}

export const VIBRATION_TIME_IN_MS = 300
export const MUSIC = 'music'
